import React from "react";
import st from "@/styles/CreditLineRequestTransaction.module.scss"
import Button from "@/ui/Button.tsx"
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import RangeSlide from "@/components/calculator_components/RangeSlide.tsx";
import useLoans from "@/hooks/loans.ts";
import Pay from "@/components/Pay.tsx";
import LoanInterface from "@/types_and_interfaces/loan_interface.ts";

interface CreditLineRequestTransactionProps {
    is_credit_line_page?:boolean
    money: any
    moneyHandler(n:number):void
    mobile?:boolean
    onSubmit(e:React.FormEvent<HTMLFormElement>):void
    credit_line: LoanInterface,
    user_again_kyc?: boolean
}

const CreditLineRequestTransaction:React.FC<CreditLineRequestTransactionProps> = (props) => {
    const {
        is_credit_line_page,
        money,
        moneyHandler,
        mobile,
        onSubmit,
        credit_line
    } = props

    const {t} = useTranslation()
    const loans = useLoans()
    const disabledStatuses = ["pending_approval", "approved_and_need_sign"];
    const current = loans.get_last_cr_line();
    const enable = current?.transactions?.filter(x => disabledStatuses.includes(x.status)) ?? [];
    const disabled = enable.length > 0 || !credit_line?.is_transaction_application_allowed;
    const not_enough_money = money < 3000

    return (
        <div className={clsx(st.column_right, mobile && st.mobile)}>
            <form className={clsx(st.container, st.request, is_credit_line_page && st.modal)} onSubmit={onSubmit}>
                <strong>
                    {t("request_transaction")}
                </strong>

                {(() => {
                    return (
                        <RangeSlide
                            name={"amount"}
                            value={money}
                            label={t("amount")}
                            from={Number(current?.avail_capital) <= 3000 ? 0 : 3000 }
                            to={Number(current?.avail_capital) || 0}
                            onChange={moneyHandler}
                            segments_qt={1}
                            unity={t("currency")}
                            unityInSegments={true}
                            // input_border
                            money
                            step_length={100}
                        />
                    )
                })()}

                {money < 3000 && (
                    <span className={st.warn}>
                        {t("min_mount_warn_cr_line")}
                    </span>
                )}

                <div className={st.controllers}>
                    <Button
                        type={"submit"}
                        animated
                        disabled={disabled || not_enough_money}
                    >
                        <span>
                            {t("send_request")}
                        </span>
                    </Button>

                    {(disabled && !not_enough_money) && (
                        <>
                            {!!enable.length && (
                                <span className={st.warn}>
                                    {t("record_already_exists")}
                                </span>
                            )}

                            {(!enable.length && !credit_line?.is_transaction_application_allowed) && (
                                <span className={st.warn}>
                                    {t("denied_apply_cr_line")}
                                </span>
                            )}
                        </>
                    )}
                </div>

                {Number(current?.avail_capital) <= 0 && (
                    <div className={st.blocked}>
                        <strong>
                            {t("unavailable_capital")}
                        </strong>
                    </div>
                )}
            </form>

            {!is_credit_line_page && (
                <Pay credit={current}/>
            )}
        </div>
    )
}

export default CreditLineRequestTransaction